import script from "./Aside.vue?vue&type=script&setup=true&lang=js"
export * from "./Aside.vue?vue&type=script&setup=true&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=149678ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-149678ea"]])

export default __exports__